export type ActionTableSortParamsType = {
  column: string;
  isAsc: boolean;
};

export const defaultActionTableSortParams: ActionTableSortParamsType = {
  column: '',
  isAsc: false,
};
